// apiService.js
import { API_BASE_URL,API_KEY } from '../constants';


export async function get(endpoint) {
  try {
    const headers = new Headers({
      'X-Api-Key': API_KEY,
      'Content-Type': 'application/json',
    });

    const  full_url = `${API_BASE_URL}/${endpoint}`
    console.log(full_url)
    const response = await fetch(full_url, {
      method: 'GET',
      mode: 'cors',
      headers: headers,
    });

    if (!response.ok) {
      console.error(`HTTP Error: ${response.status} - ${response.statusText}`);
      const errorResponseText = await response.text();
      console.error('Error Response:', errorResponseText);
      throw new Error('Network response was not ok');
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error fetching data from API', error);
    throw error;
  }
}




export async function post(endpoint, data) {
  try {
    const headers = new Headers({
      'X-Api-Key': API_KEY,
      'Content-Type': 'application/json',
    });

    const  full_url = `${API_BASE_URL}/${endpoint}`
    console.log(full_url)

    const response = await fetch(full_url, {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const responseData = await response.json();

    return responseData;
  } catch (error) {
    console.error('Error posting data to the API', error);
    throw error;
  }
}
